import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const Slice = ({ children, size, topDelimiter = false, bottomDelimiter = false, className, style, }) => (_jsx("section", { className: clsx(className, 'z-101', topDelimiter && 'delimiter-top', bottomDelimiter && 'delimiter-bottom', size === 'lg' ? 'slice-lg' : 'slice'), style: { background: 'none', ...style }, children: children }));
export default Slice;
//# sourceMappingURL=Slice.js.map